// searchUtils.js

export const clearAllHighlights = () => {

    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT, null, false);

    let node;
    const nodesToClear = [];

    while ((node = walker.nextNode())) {
        const bgColor = node.style?.backgroundColor;
        if (bgColor && bgColor !== '') {
            nodesToClear.push(node);
        }
    }

    nodesToClear.forEach((node) => {
        const parent = node.parentNode;
        const textNode = document.createTextNode(node.textContent);
        parent.replaceChild(textNode, node);
        parent.normalize(); // Clean up adjacent text nodes
    });
};


export const highlightSearchTerms = (text, backgroundColor) => {

    if (window.find && window.getSelection) {
        document.designMode = "on";
        var sel = window.getSelection();
        sel.collapse(document.body, 0);
        while (window.find(text)) {
            document.execCommand("HiliteColor", false, backgroundColor);
            document.execCommand("foreColor", false, '#000');
            sel.collapseToEnd();
        }
        document.designMode = "off";
    }

}